import React, { useRef } from 'react';
import { MeasuredContainer, } from '../Measured';
import GridRow from './GridRow';
import useScreenBounds from '../utils/hooks/useScreenBounds';
var SCROLL_TIMEOUT = 500;
var VISIBLE_PADDING = 300;
// See https://zpl.io/VKPoDRR
export var BREAKPOINTS = [
    { maxWidth: 480, elementWidth: 250, elementHeight: 250 },
    { maxWidth: 1024, elementWidth: 304, elementHeight: 261 },
    { maxWidth: 1280, elementWidth: 288, elementHeight: 247 },
    { maxWidth: 1366, elementWidth: 299, elementHeight: 257 },
    { maxWidth: 1920, elementWidth: 347, elementHeight: 300 },
];
var Grid = function (_a) {
    var cookieType = _a.cookieType, measureWindow = _a.measureWindow, elementCount = _a.elementCount, className = _a.className, spacing = _a.spacing, breakpoints = _a.breakpoints, renderElement = _a.renderElement, getElementId = _a.getElementId, getDuperbrowseItemId = _a.getDuperbrowseItemId, _b = _a.enableScrollOptim, enableScrollOptim = _b === void 0 ? false : _b;
    var containerRef = useRef(null);
    var windowBounds = useScreenBounds(containerRef, SCROLL_TIMEOUT, VISIBLE_PADDING, enableScrollOptim);
    return (React.createElement("div", { ref: containerRef },
        React.createElement(MeasuredContainer, { listenOnWindow: true, limitToParentWidth: true, cookieType: cookieType, cookieDim: "width", measureWindow: measureWindow }, function (props) {
            var containerWidth;
            if (props.container) {
                containerWidth = props.container.width;
            }
            if (!containerWidth) {
                containerWidth = 1024;
            }
            var _a = getConfiguration(containerWidth, spacing, breakpoints), width = _a.width, height = _a.height, spacingH = _a.spacingH, spacingV = _a.spacingV, elementsPerRow = _a.elementsPerRow;
            var rows = [];
            for (var i = 0, a = 0; i < elementCount; i += elementsPerRow, a++) {
                rows.push(React.createElement(GridRow, { rowNumber: a, bounds: enableScrollOptim ? windowBounds : undefined, key: "grid-row" + i, renderElement: renderElement, getElementId: getElementId, getDuperbrowseItemId: getDuperbrowseItemId, start: i, end: Math.min(i + elementsPerRow, elementCount), width: width, height: height, spacingH: spacingH, spacingV: i > 0 ? spacingV : 0 }));
            }
            return (React.createElement("div", { ref: props.onRef, className: className }, rows));
        })));
};
Grid.displayName = 'Grid';
function getConfiguration(containerWidth, spacing, breakpoints) {
    if (spacing === void 0) { spacing = 16; }
    if (breakpoints === void 0) { breakpoints = BREAKPOINTS; }
    var spacingH = typeof spacing === 'object' ? spacing.horizontal : spacing;
    var spacingV = typeof spacing === 'object' ? spacing.vertical : spacing;
    var point = breakpoints.find(function (p, idx) {
        return containerWidth <= p.maxWidth || idx === breakpoints.length - 1;
    }) || BREAKPOINTS[0];
    var targetWidth = point.elementWidth;
    // We try to place X elements per row such that width of elements is as close
    // to targetWidth as possible, but not greater
    var elementsPerRow = Math.floor((containerWidth + spacingH) / (targetWidth + spacingH));
    elementsPerRow = Math.max(elementsPerRow, 1);
    var width = (containerWidth - (elementsPerRow - 1) * spacingH) / elementsPerRow;
    var height = (point.elementHeight * width) / point.elementWidth;
    return { width: width, height: height, spacingH: spacingH, spacingV: spacingV, elementsPerRow: elementsPerRow };
}
export default Grid;
//# sourceMappingURL=Grid.js.map